import { render, staticRenderFns } from "./CaseFilters.vue?vue&type=template&id=a796e6c4&scoped=true&"
import script from "./CaseFilters.vue?vue&type=script&lang=ts&"
export * from "./CaseFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a796e6c4",
  null
  
)

export default component.exports